var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "b-modal",
    {
      ref: "changeBidModal",
      attrs: { id: "change-bid", title: "Change bid" },
      on: { ok: _vm.changeBid }
    },
    [
      _c("div", { staticClass: "item-place-bid" }, [
        _c("div", { staticClass: "title-place-bid" }, [
          _vm._v("\n            Estimated Landed Cost\n        ")
        ]),
        _vm._v(" "),
        _c("div", { staticClass: "form-group inline-label" }, [
          _c(
            "label",
            {
              staticStyle: { "text-transform": "uppercase" },
              attrs: { for: "change-bid-landed" }
            },
            [
              _vm._v(
                "\n                " +
                  _vm._s(_vm.user_currency_code) +
                  " " +
                  _vm._s(_vm.user_currency_sign) +
                  "\n            "
              )
            ]
          ),
          _vm._v(" "),
          _c("input", {
            directives: [
              {
                name: "model",
                rawName: "v-model",
                value: _vm.estimatedLandedCost,
                expression: "estimatedLandedCost"
              }
            ],
            ref: "changeBidLanded",
            attrs: {
              id: "change-bid-landed",
              type: "text",
              name: "estimatedLandedCost",
              value: "",
              placeholder: "12,345"
            },
            domProps: { value: _vm.estimatedLandedCost },
            on: {
              input: [
                function($event) {
                  if ($event.target.composing) {
                    return
                  }
                  _vm.estimatedLandedCost = $event.target.value
                },
                _vm.onLandedCostInput
              ]
            }
          })
        ])
      ]),
      _vm._v(" "),
      _c("div", { staticClass: "item-place-bid" }, [
        _c("div", { staticClass: "title-place-bid" }, [
          _vm._v("\n            Place Bid (in thousands of yen)\n        ")
        ]),
        _vm._v(" "),
        _c("div", { staticClass: "form-group inline-label" }, [
          _c("label", { attrs: { for: "change-bid-jpy" } }, [_vm._v("JPY ¥")]),
          _vm._v(" "),
          _c("input", {
            directives: [
              {
                name: "model",
                rawName: "v-model",
                value: _vm.bidPriceProxy,
                expression: "bidPriceProxy"
              }
            ],
            attrs: {
              id: "change-bid-jpy",
              type: "text",
              value: "",
              placeholder: "220"
            },
            domProps: { value: _vm.bidPriceProxy },
            on: {
              input: [
                function($event) {
                  if ($event.target.composing) {
                    return
                  }
                  _vm.bidPriceProxy = $event.target.value
                },
                _vm.onBidPriceInput
              ]
            }
          })
        ])
      ]),
      _vm._v(" "),
      _vm.$userIsAdmin()
        ? _c("div", { staticClass: "item-place-bid" }, [
            _c("div", { staticClass: "title-place-bid" }, [
              _vm._v("\n            Bump Bid\n        ")
            ]),
            _vm._v(" "),
            _c("div", { staticClass: "form-group inline-label" }, [
              _vm._v(
                "\n            JPY ¥ " +
                  _vm._s(_vm.numberWithCommas(_vm.bumpBid)) +
                  "\n        "
              )
            ])
          ])
        : _vm._e()
    ]
  )
}
var staticRenderFns = []
render._withStripped = true
module.exports = { render: render, staticRenderFns: staticRenderFns }
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-3acc9892", module.exports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-3acc9892","hasScoped":false,"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./resources/js/components/VehicleSingle/ChangeBid.vue
// module id = ./node_modules/vue-loader/lib/template-compiler/index.js?{"id":"data-v-3acc9892","hasScoped":false,"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./resources/js/components/VehicleSingle/ChangeBid.vue
// module chunks = 0